module.exports = __webpack_public_path__ + "img/waistline_back_pocket_position.bc9c0637.png";